<img src="./assets/img/logo.png" alt="" class="headline">
<h1>{{ "headline" | translate}}</h1>